<template>
	<div class="notifications" @click.stop="() => {}">
		<!-- <span class="stackng-length">
			You have {{notifs.length}} new notifications
		</span>-->
		<div class="tabs is-centered">
			<ul>
				<li class="follows active-tab">
					<a @click="switchTabs('follows')">
						Activity
						<span class="count">{{activityNotifs.length}}</span>
					</a>
				</li>
				<li class="groups">
					<a @click="switchTabs('groups')">
						Groups
						<span class="count">{{groupsNotifs.length}}</span>
					</a>
				</li>
			</ul>
		</div>
		<ul v-show="currentTab === 'follows'" class="follows-list">
			<transition-group tag="div" name="slide-fade" v-if="activityNotifs.length > 0">
				<notifications-list-item v-for="notif of activityNotifs" :notifItem="notif" :key="notif.id"></notifications-list-item>
			</transition-group>
			<no-content v-else :header="noContentHeader" :paragraph="noContentParagraph"></no-content>
		</ul>
		<ul v-show="currentTab === 'groups'" class="groups-list">
			<transition-group tag="div" name="slide-fade" v-if="groupsNotifs.length > 0">
				<notifications-list-item v-for="notif of groupsNotifs" :notifItem="notif" :key="notif.id"></notifications-list-item>
			</transition-group>
			<no-content v-else :header="noContentHeader" :paragraph="noContentParagraph"></no-content>
		</ul>
	</div>
</template>

<script>
import NotificationsListItem from "./NotificationsListItem.vue";
import NoContent from "../errors/NoContent.vue";

export default {
	data() {
		return {
			currentTab: "follows",
			noContentParagraph: "Please check again later"
		};
	},
	props: {
		notifs: {
			type: Array
		}
	},
	components: {
		NotificationsListItem,
		NoContent
	},
	computed: {
		notifications() {
			return this.$store.getters.getNotifications;
		},
		activityNotifs() {
			return this.notifications.filter(item => {
				return (
					item.type === "welcome" ||
					item.type === "follow" ||
					item.type.includes("unlocked")
				);
			});
		},
		groupsNotifs() {
			return this.notifications.filter(item => {
				return (
					item.type === "group-created" ||
					item.type === "group-deleted" ||
					item.type === "group-admin-change"
				);
			});
		},
		noContentHeader() {
			let header = this.currentTab === "groups" ? "groups" : "";
			return `You do not have any ${header} notification`;
		}
	},
	methods: {
		switchTabs(tabName) {
			this.currentTab = tabName;

			document.querySelector(".active-tab").classList.remove("active-tab");
			// document.querySelector(`.${this.currentTab}`).classList.add('active-tab')

			switch (this.currentTab) {
				case "follows":
					document
						.querySelector(`.${this.currentTab}`)
						.classList.add("active-tab");
					break;
				case "groups":
					document
						.querySelector(`.${this.currentTab}`)
						.classList.add("active-tab");
					break;
			}
		}
	}
};
</script>

<style scoped>
.stackng-length {
	text-align: center;
	font-size: 12px;
	color: #51c715;
	margin: 10px auto 10px;
	padding: 3px 10px;
	border: 1px solid #51c715;
	border-radius: 20px;
	width: fit-content;
	display: block;
}

.tabs {
	margin-bottom: 0px;
}

.tabs ul {
	border-bottom: none;
}

.tabs li {
	width: 50%;
	border-bottom: 1px solid #000;
}

.tabs li.active-tab a,
.tabs li.active-tab a:hover {
	color: #51c715;
	border-bottom: 1px solid #51c715 !important;
}

.tabs li a {
	/* border: none; */
	border-bottom: 1px solid #000;
	/* padding: 15px 0; */
	display: block;
	text-align: center;
	font-size: 13px;
	font-weight: 700;
	transition: 0.3s ease all;
	color: #fff;
}

.notifications-sub-menu .tabs li a {
	padding: 12px 0;
}

.tabs li a:hover {
	color: #fff;
	border-bottom-color: #1e4609;
}

.follows-list,
.groups-list {
	max-height: 400px;
	overflow: auto;
	/* margin-right: 10px; */
}

.count {
	height: 15px;
	width: 15px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/notifications/NotificationsList.vue